import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api-client";
import type { UserConnectedAccount } from "@adva/types";

interface ConnectedAccountsResponse {
  accounts: UserConnectedAccount[];
}

interface ConnectResponse {
  auth_url: string;
}

const QUERY_KEY = ["user-connected-accounts"] as const;

export function useConnectedAccounts() {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: () =>
      api.get<ConnectedAccountsResponse>("/user/connected-accounts"),
  });
}

export function useConnectAccount() {
  return useMutation({
    mutationFn: ({
      provider,
      capabilities,
    }: {
      provider: string;
      capabilities: string[];
    }) =>
      api.post<ConnectResponse>(
        `/user/connected-accounts/${provider}/connect`,
        { capabilities },
      ),
  });
}

export function useDisconnectAccount() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (provider: string) =>
      api.post<{ message: string }>(
        `/user/connected-accounts/${provider}/disconnect`,
        {},
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEY });
    },
  });
}
